import {
  createImageUrlBuilder,
  type SanityImageSource,
} from '@sanity/image-url'
import { type LocalizedContent } from './i18n.ts'

export const sanityProjectId = '8cdi2n44'
const sanityDataset =
  typeof window === 'undefined'
    ? process.env.SANITY_DATASET
    : window.ENV?.SANITY_DATASET

export interface Image {
  content: SanityImageSource
  alt: LocalizedContent
}

const sanityImageUrlBuilder = createImageUrlBuilder({
  projectId: sanityProjectId,
  dataset: sanityDataset,
})

export const imageUrlFor = (source: SanityImageSource) =>
  sanityImageUrlBuilder.image(source)

interface SanityReference {
  _ref: string
}

export const fileUrlFor = (reference: SanityReference) => {
  const referenceParts = reference._ref.split('-')
  const filename = referenceParts.slice(1).join('.')

  return `https://cdn.sanity.io/files/${sanityProjectId}/${sanityDataset}/${filename}`
}
